import { createStyles } from '@mantine/core';

export const MARKETPLACE_PILL_ICON_SIZE = 24;

const MODAL_MIN_WIDTH = 500;
export const VIEW_ENTRY_ICON_SIZE = 16;

export const useStyles = createStyles((theme) => ({
  body: {
    minWidth: MODAL_MIN_WIDTH,

    [theme.fn.smallerThan('sm')]: {
      minWidth: '100%',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.other.spacing._2,
    textAlign: 'center',
  },
  entryOrder: {
    color: theme.colors.gray2[3],
  },
  marketplacePill: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    gap: theme.other.spacing._8,
    padding: `${theme.other.spacing._6}px ${theme.other.spacing._8}px`,
    borderRadius: theme.radius.xl,
    background: `${theme.other.color.marketplace.gradientFrom}26`,
  },
  ownership: {
    display: 'flex',
    alignItems: 'stretch',
    padding: theme.other.spacing._8,
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.gray2[0],
  },
  ownershipCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._2,
    flex: 1,
  },
  ownershipValue: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
  },
  ownershipLabel: {
    color: theme.colors.gray2[3],
  },
  ownershipDivider: {
    width: 1,
    margin: `${theme.other.spacing._6}px 0`,
    backgroundColor: theme.colors.gray2[1],
  },
  pickControlYes: {
    color: theme.colors.green[6],
  },
  pickControlNo: {
    color: theme.colors.gray2[3],
  },
  shareholders: {
    display: 'flex',
    flexDirection: 'column',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._12,
  },
  viewEntryLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.other.spacing._6,
  },
}));
